import styled from 'styled-components';

const EngagementContainer = styled.div``;

export { EngagementContainer };
